var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.productPowerReviewsId)?_c('div',[_c('div',{staticClass:"pr-reviewsnippet pr-reviewsnippet--min-height",attrs:{"id":("pr-reviewsnippet-" + _vm.productPowerReviewsId)}},[_c('div',{attrs:{"data-pr-placeholder":""}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }